"use client";
import { ProcessedCourse } from "@/common/course/types";
import Icon from "@/components/icons";
import Link from "next/link";

interface PaymentOptionsProps {
  title?: string;
  description?: string;
  courseCost?: string;
}

export default function PaymentOptions({
  title,
  description,
  courseCost,
}: PaymentOptionsProps) {
  return (
    <section id="payment-options">
      <div className="flex items-center justify-between gap-8 ">
        <div className={`flex-1 ${courseCost ? "pr-24" : ""}`}>
          <h2 className="mb-4 text-3xl font-bold text-foreground">{title}</h2>
          <p className="mb-4 text-base leading-relaxed text-muted-foreground">
            {description}
          </p>
          <p className="text-sm font-bold text-muted-foreground">
            Technology and services powered by 2U, LLC, the parent company of
            edX.
          </p>
        </div>

        {courseCost && (
          <div className="flex flex-col items-center gap-2 flex-shrink-0">
            <div className="flex items-center justify-center">
              <Icon
                type="money-outline"
                svgProps={{ width: "32px", height: "32px" }}
              />
            </div>
            <span className="text-md text-muted-foreground">Course cost</span>
            <span className="font-bold text-2xl text-foreground">
              {courseCost}
            </span>
          </div>
        )}
      </div>
    </section>
  );
}
